module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/1/2-6d83c66b28e4aa764bdd5094610f004f.jpg";